import { createContext, useContext, useMemo, useState } from "react";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";

const VisualEffectsContext = createContext({});

export const VisualEffectsProvider = ({ children }) => {
  const [confettiStack, setConfettiStack] = useState([]);
  const { width, height } = useWindowSize();

  const ctx = useMemo(
    () => ({
      triggerBriefConfetti: ({ id = Math.random() } = {}) => {
        setConfettiStack((prev) => [...prev, id]);
      },
    }),
    [],
  );

  return (
    <VisualEffectsContext.Provider value={ctx}>
      <>
        {children}
        {confettiStack.map((id) => (
          <Confetti
            key={id}
            width={width}
            height={height}
            numberOfPieces={300}
            recycle={false}
            tweenDuration={1000}
            gravity={0.25}
            friction={0.99}
            onConfettiComplete={() =>
              setConfettiStack((prev) => prev.filter((itemId) => id !== itemId))
            }
            style={{ zIndex: 1400 }}
          />
        ))}
      </>
    </VisualEffectsContext.Provider>
  );
};

export const useVisualEffects = () => useContext(VisualEffectsContext);
